module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./client/app/labour-cost/labour-cost.component.scss
// module id = ./client/app/labour-cost/labour-cost.component.scss
// module chunks = main